var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showIcon)?_c('div',{staticClass:"whatsapp"},[_c('v-icon',{attrs:{"dark":"","color":"white"}},[_vm._v("mdi-whatsapp")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }